import Box from '@mui/material/Box';
import { cardIssuerLabel } from '@/models/payments/Transaction';

// Card-type pill styled to match the receipt's `.card-brand` treatment: uppercase bold friendly name in a
// rounded chip.
const CardBrandChip = ({ issuer }: { issuer: string }) => (
    <Box
        component="span"
        sx={{
            // Don't stretch to the DataGrid cell's full height — sit at natural height, centered, so there's
            // a little breathing room above and below the pill.
            alignSelf: 'center',
            fontSize: '0.7rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            padding: '8px 16px',
            borderRadius: '4px',
            backgroundColor: '#eef2f6',
            color: '#334e68',
            whiteSpace: 'nowrap',
        }}
    >
        {cardIssuerLabel(issuer)}
    </Box>
);

export default CardBrandChip;
